import React, { Component } from "react";
import Downshift from "downshift";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";
import axios from "axios";
const axiosInstance = axios.create({
  baseURL: "",
  timeout: 30000,
});

const styles = {
  container: {
    position: "relative",
    zIndex: 20,
    marginTop: "-0.5px",
  },
  input: {
    fontSize: 18,
    height: 38,
  },
  option: {
    fontSize: 14,
  },
};

function renderInput(inputProps) {
  const { InputProps, classes, classesProps, ref, ...other } = inputProps;
  const inputClass = classesProps.input ? classesProps.input : classes.input;
  return (
    <TextField
      label="Player"
      {...other}
      inputRef={ref}
      InputProps={{
        classes: {
          input: inputClass,
        },
        ...InputProps,
      }}
    />
  );
}

function debounce(fn, time) {
  let timeoutId;
  return wrapper;
  function wrapper(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, time);
  }
}

class PlayerDropdownSearch extends Component {
  state = { items: [] };
  fetchRepository = debounce((value, prmIdAgent, agentFilter) => {
    this.setState({
      items: [
        {
          pid: "",
          player: "loading...",
        },
      ],
    });
    const payloadPlayerFind = encodeURIComponent(
      JSON.stringify({
        agentFilter,
        prmIdAgent,
        Term: value,
      })
    );
    axiosInstance
      .get(`PlayerFindHelper.aspx?payload=${payloadPlayerFind}`)
      .then((response) => {
        this.setState({ items: response.data.list });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ items: [] });
      });
  }, 300);

  render() {
    const {
      classes,
      classesProps,
      agentFilter,
      onSelectPlayer,
      onEnter,
      prmIdAgent,
      displayAllPlayers,
      defaultInputVal,
      onChangeOutside,
    } = this.props;
    const containerStyles = classesProps.container
      ? classesProps.container
      : {};
    return (
      <Downshift
        onChange={(selectedItem) => {
          if (selectedItem !== "All Players" && selectedItem !== "loading...") {
            const { pid, player } = _.chain(this.state.items)
              .find(({ player }) => player === selectedItem)
              .value();
            onSelectPlayer(`${pid}|${player}`);
          } else {
            onSelectPlayer("-1|All Players");
          }
        }}
      >
        {({
          selectedItem,
          getInputProps,
          getItemProps,
          highlightedIndex,
          isOpen,
        }) => {
          return (
            <div className={classes.container} style={containerStyles}>
              {renderInput({
                fullWidth: true,
                classes,
                classesProps,
                InputProps: getInputProps({
                  placeholder: "Find Player...",
                  id: "integration-downshift",
                  onKeyPress: (ev) => {
                    if (ev.key === "Enter") {
                      ev.preventDefault();
                      onEnter();
                    }
                  },
                  onChange: (event) => {
                    const value = event.target.value;
                    if (!value) {
                      return;
                    }
                    // call the debounce
                    if (defaultInputVal !== null) {
                      onChangeOutside(value);
                    }
                    this.fetchRepository(value, prmIdAgent, agentFilter);
                  },
                  ...(defaultInputVal !== null && { value: defaultInputVal }),
                }),
              })}
              {isOpen && (
                <Paper
                  square
                  style={{
                    zIndex: 20,
                    position: "absolute",
                    width: "100%",
                  }}
                >
                  {displayAllPlayers && (
                    <MenuItem
                      component="div"
                      classes={{
                        root: classesProps.option
                          ? classesProps.option
                          : classes.option,
                      }}
                      {...getItemProps({
                        item: "All Players",
                      })}
                    >
                      All Players
                    </MenuItem>
                  )}
                  {(this.state.items || []).map((item, index) => (
                    <MenuItem
                      key={index}
                      component="div"
                      classes={{
                        root: classesProps.option
                          ? classesProps.option
                          : classes.option,
                      }}
                      {...getItemProps({
                        item: item.player,
                      })}
                    >
                      {item.player}
                    </MenuItem>
                  ))}
                </Paper>
              )}
            </div>
          );
        }}
      </Downshift>
    );
  }
}

PlayerDropdownSearch.propTypes = {
  classes: PropTypes.object.isRequired,
  prmIdAgent: PropTypes.string.isRequired,
  classesProps: PropTypes.object,
  agentFilter: PropTypes.bool.isRequired,
  onSelectPlayer: PropTypes.func.isRequired,
  displayAllPlayers: PropTypes.bool.isRequired,
  defaultInputVal: PropTypes.string,
  onChangeOutside: PropTypes.func,
  onEnter: PropTypes.func,
};

PlayerDropdownSearch.defaultProps = {
  onEnter: () => {},
  classesProps: {},
  agentFilter: true,
  displayAllPlayers: true,
  defaultInputVal: null,
};

export default withStyles(styles)(PlayerDropdownSearch);
